import { render, staticRenderFns } from "./AccommodationTab.vue?vue&type=template&id=246acfc8&scoped=true&"
import script from "./AccommodationTab.vue?vue&type=script&lang=js&"
export * from "./AccommodationTab.vue?vue&type=script&lang=js&"
import style0 from "./AccommodationTab.vue?vue&type=style&index=0&id=246acfc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246acfc8",
  null
  
)

component.options.__file = "AccommodationTab.vue"
export default component.exports